export enum ViewType {
  card = 'card',
  list = 'list'
}
